import { useTranslation } from "react-i18next";

import { formatedDate } from "utils";
import { Typography } from "@atoms";

import { Divider, StoryParent } from "../storyFace.styles";
import { useStoryDataContext } from "contexts/StoryContext";
import StoryCreatorActions from "./storyCreatorActions";

function StoryInfo() {
  const { t } = useTranslation();
  const { story, isCreator } = useStoryDataContext();

  if (!story) return <></>;

  const status = [t("relative"), t("friend"), t("publicFace")];

  const hasBirthDate = story.date_of_birth_year || story.date_of_birth_month || story.date_of_birth_day;
  const hasDeathDate = story.date_of_death_year || story.date_of_death_month || story.date_of_death_day;

  const title = !story.is_alive
    ? t("yearsOfLife")
    : t("born");

  return (
    <StoryParent>
      {isCreator && <StoryCreatorActions />}
      <Typography style={{ color: "#C6A691" }}>
        {/*{window.location.hostname.includes("animals")*/}
        {/*  ? "Питомец"*/}
        {/*  : status[story.status]}*/}
      </Typography>
      <Typography as="h2" style={{ marginBottom: "20px" }}>
        {story.name}
      </Typography>

      <>
        <Typography style={{ color: "#C6A691", marginBottom: "4px" }}>{title}</Typography>
        <div style={{ display: "flex", gap: "5px", marginBottom: "20px" }}>
          <Typography as="p">
            {hasBirthDate && (
              formatedDate(
                story?.date_of_birth_year,
                story?.date_of_birth_month,
                story?.date_of_birth_day
              )
            )}
            {!hasBirthDate && t("unknown")}

            {!story.is_alive && " - "}

            {hasDeathDate && (
              formatedDate(
                story?.date_of_death_year,
                story?.date_of_death_month,
                story?.date_of_death_day
              )
            )}
            {!story.is_alive && !hasDeathDate && t("unknown")}
          </Typography>
        </div>
      </>

      {story.place_of_birth && (
        <>
          <Typography style={{ color: "#C6A691", marginBottom: '4px' }}>
            {t("placeOfBirth")}
          </Typography>
          <Typography as="h4">{story.place_of_birth}</Typography>
        </>
      )}

      {story.description && <Divider />}

      {story.description && (
        <Typography>{story.description}</Typography>
      )}
    </StoryParent>
  );
};

export default StoryInfo;
